( function () {
	'use strict';

	function TreeListViewController ( $scope, $filter, _ ) {
		var observation, currentScript, obsGroups;

		// this is for filtering script evidences
		function filterItem ( type ) {
			return function ( item ) {
				return item.type === type;
			};
		}

		function pushToList ( area, groupId ) {
			var areaData = {
				'name'    : area.name || area.questionText,
				'id'      : area.id,
				'groupId' : groupId
			};

			$scope.list.push( areaData );
		}

		function searchEvidence ( array, note, groupId ) {
			angular.forEach( array, function ( area ) {
				if ( _.find( area.evidences, { 'id' : note.id } ) ) {
					pushToList( area, groupId );
				}

				if ( area.indicators ) {
					searchEvidence( area.indicators, note, area.id );
				}
			} );
		}

		function changeList ( note ) {
			currentScript = note;

			$scope.list = [];
			searchEvidence( obsGroups, note );
		}

		function checkList ( id ) {
			return _.find( $scope.list, { 'id' : id } );
		}

		function attachScript ( area ) {
			var group = _.find( obsGroups, { 'id' : area.id } );

			if ( !group ) {
				angular.forEach( obsGroups, function ( item ) {
					var indicator = _.find( item.indicators, { 'id' : area.id } );

					if ( indicator ) {
						if ( !indicator.evidences ) {
							indicator.evidences = [ ];
						}

						indicator.evidences.push( currentScript );
						pushToList( indicator, item.id );
					}
				} );
			} else {
				if ( !group.evidences ) {
					group.evidences = [ ];
				}

				group.evidences.push( currentScript );
				pushToList( group );
			}
		}

		function detachScript ( area ) {
			var detachArea = _.find( obsGroups, { 'id' : area.id } );

			if ( area.groupId ) {
				var group = _.find( obsGroups, { 'id' : area.groupId } );

				detachArea = _.find( group.indicators, { 'id' : area.id } );
			}

			detachArea.evidences.splice( detachArea.evidences.indexOf( currentScript ), 1 );
			$scope.list.splice( $scope.list.indexOf( area ), 1 );
		}

		function attachDetach ( area ) {
			var data = checkList( area.id );

			if ( data ) {
				detachScript( data );
			} else {
				attachScript( area );
			}
		}

		function expandGroups ( expand ) {
			$scope.expandAll = expand;

			angular.forEach( $scope.groups, function ( item ) {
				item.expand = expand;
			} );
		}

		function checkExpand () {
			var extendGroups = true;

			angular.forEach( $scope.groups, function ( item ) {
				if ( !item.expand ) {
					extendGroups = false;
					return;
				}
			} );

			if ( !extendGroups ) {
				$scope.expandAll = false;
			} else {
				$scope.expandAll = true;
			}
		}

		function expandCollapse () {
			$scope.expandAll = !$scope.expandAll;
			expandGroups( $scope.expandAll );
		}

		function selectScript () {
			$scope.list = [ ];
			var scriptEvidences = $filter( 'filter' )( observation.masterEvidences, filterItem( 8 ) );

			if ( scriptEvidences.length === 0 ) {
				$scope.$parent.$parent.vm.attachMode = false;
				return;
			}

			changeList( scriptEvidences[ 0 ] );
			$scope.$root.$broadcast( 'select:script', scriptEvidences[ 0 ].id );
		}

		function activate () {
			observation = $scope.$parent.$parent.observation;

			// this is for attach/detach
			obsGroups = observation.template.groups;

			// this is for displaying the data and for the expand feature
			$scope.groups = angular.copy( observation.template.groups );

			selectScript();

			expandGroups( $scope.groups.length < 2 );
		}

		activate();

		$scope.detachScript   = detachScript;
		$scope.attachDetach   = attachDetach;
		$scope.checkList      = checkList;
		$scope.checkExpand    = checkExpand;
		$scope.expandCollapse = expandCollapse;

		$scope.$on( 'change:list', function ( ev, note ) {
			if ( note.id !== currentScript.id ) {
				changeList( note );
			}
		} );

		$scope.$on( 'update:tree:list', function () {
			selectScript();
		} );
	}

	angular.module( 'app.components' )
		.controller( 'TreeListViewController', TreeListViewController );

	TreeListViewController.$inject = [ '$scope', '$filter', '_' ];
} )( );
